import React, {FC} from "react";
import cls from "./customInnerPage.module.scss";
import Slider from "react-slick";
import {IProduct} from "../../../types/homePageTypes";
import BlockHeader from "../Products/BlockHeader";
import ProductCard from "../Products/ProductCard";
import {IBlockProductProps} from "../Products/BlockProducts";

interface IProps extends IBlockProductProps {
    title: string,
    products: Array<IProduct>;
}

const CustomRelatedBlock: FC<IProps> = (
    {
        title,
        products,
        dbName,
        translationsData,
        backOrderValue,
        selectedCurrItems,
        selectedLocale
    }
) => {

    const settings = {
        slidesToShow: 4,
        arrows: false,
        infinite: false,
        swipeToSlide: true,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 425,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    }

    return <div className={cls.related_block}>
        <div className="container">
            <BlockHeader title={title}/>
            <Slider {...settings}>
                {
                    products.map((product) => {
                        return <ProductCard
                            key={product.id}
                            product={product}
                            dbName={dbName}
                            translationsData={translationsData}
                            backOrderValue={backOrderValue}
                            selectedCurrItems={selectedCurrItems}
                            selectedLocale={selectedLocale}
                            priority={false}
                            loading={"lazy"}
                        />
                    })
                }
            </Slider>
        </div>
    </div>
};

export default CustomRelatedBlock;
